import { Link } from 'react-router-dom';

const BrandMark = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" aria-hidden="true">
    <path
      d="M11 9.5h7.5C26 9.5 31 13.7 31 20s-5 10.5-12.5 10.5H11v-21Z"
      stroke="white"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m15.5 20 3.2 3.2 6.3-7"
      stroke="#99f6e4"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DediAsinMain = () => {
  return (
    <main className="dedi-page">
      <section className="hero">
        <div className="hero-bg" aria-hidden="true">
          <span></span>
          <span></span>
        </div>
        <div className="hero-grid">
          <div>
            <div className="pills">
              <span className="pill"><i className="ri-checkbox-circle-line"></i> 現場へ納品し、稼働中</span>
              <span className="pill pill--line"><i className="ri-settings-4-line"></i> 貴社の体制に合わせて調整</span>
            </div>
            <div className="brand">
              <div className="brand-mark">
                <BrandMark />
              </div>
              <div>
                <h1>DediAsin</h1>
                <p>SHIFT MANAGEMENT</p>
              </div>
            </div>
            <p className="catch">シフトも配置も稼働も、Excelに写さず一つの画面で。</p>
            <p className="hero-copy">
              シフト管理で足りない部分をExcelで補い、同じ情報を二重に管理していませんか。<br />
              DediAsinは、スタッフの希望の提出から、配置先を3段の階層で組むこと、人ごとの稼働集計、管理者が任意で使う出勤確認、予定変更の連絡までを一つの画面にまとめます。希望をもとに配置の下地を自動で作り、管理者が必要な部分だけ直せます。組織の形に合わせて調整し、ご提供します。
            </p>
            <div className="actions">
              <Link className="btn btn--fill" to="/contact"><i className="ri-mail-send-line"></i> 導入のご相談</Link>
              <a className="btn btn--line" href="#operation-movie"><i className="ri-play-circle-line"></i> 操作説明の動画を見る（約1分15秒）</a>
              <a className="btn btn--line" href="#auto"><i className="ri-magic-line"></i> 自動配置を見る</a>
            </div>
          </div>

          <div className="merge" aria-label="二つの道具を一つにまとめるイメージ">
            <p className="merge-label">BEFORE</p>
            <div className="split-tools">
              <div className="tool">
                <strong>シフト管理サービス</strong>
                <span>希望と、おおよその勤務</span>
              </div>
              <div className="tool">
                <strong>表計算ソフト</strong>
                <span>誰がどこに入るか、時間の集計</span>
              </div>
            </div>
            <div className="merge-arrow">
              <i className="ri-arrow-down-line"></i>
              <span>二重の入力をやめて、同じデータで見る</span>
              <i className="ri-arrow-down-line"></i>
            </div>
            <div className="one-tool">
              <strong>DediAsin</strong>
              <ul>
                <li>希望の提出</li>
                <li>自動で配置の下地</li>
                <li>人別 / 勤務先別</li>
                <li>稼働時間</li>
                <li>出勤確認</li>
                <li>連絡</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="block block--tint" id="operation-movie">
        <div className="wrap">
          <div className="center">
            <p className="kicker">Operation</p>
            <h2>操作の流れを、画面のまま見る</h2>
            <p className="lead">
              希望の提出から、配置の下地づくり、人別と勤務先別の確認まで。実際の画面操作を約1分15秒にまとめています。
            </p>
          </div>
          <figure className="promo-video">
            <video
              src="/image/dediasin-operation.mp4"
              autoPlay
              loop
              muted
              playsInline
              controls
              preload="metadata"
              aria-label="DediAsinの操作説明"
            >
              お使いのブラウザは動画再生に対応していません。
            </video>
          </figure>
        </div>
      </section>

      <section className="block" id="unify">
        <div className="wrap">
          <div className="story">
            <div>
              <p className="kicker">One ledger</p>
              <h2>分かれていた仕事を、行き来せずに済ませる</h2>
              <p>
                シフトそのものは市販のサービスで足りていました。足りなかったのは、そのあとです。どの作業場に誰を置くか、人ごとの時間は何時間か。そこは表計算に写し、また戻して、という作業になっていました。
              </p>
              <p>
                DediAsin は、その写し替えをなくすために作ったシフト管理です。スタッフが希望を出し、管理者が配置を決め、稼働を見て、変更を連絡する。台帳は一つです。
              </p>
            </div>
            <div className="was-now">
              <div className="pair">
                <div className="pair-card">
                  <small>それまで</small>
                  <p>希望はシフト管理、配置の内訳は表計算</p>
                </div>
                <div className="pair-join" aria-hidden="true"><i className="ri-arrow-right-line"></i></div>
                <div className="pair-card pair-card--after">
                  <small>DediAsin</small>
                  <p>提出済みの希望から、配置まで同じ月の画面で扱う</p>
                </div>
              </div>
              <div className="pair">
                <div className="pair-card">
                  <small>それまで</small>
                  <p>人別の表と、勤務先別の表をそれぞれ保守</p>
                </div>
                <div className="pair-join" aria-hidden="true"><i className="ri-arrow-right-line"></i></div>
                <div className="pair-card pair-card--after">
                  <small>DediAsin</small>
                  <p>同じ確定シフトを、見る軸だけ切り替えて確認</p>
                </div>
              </div>
              <div className="pair">
                <div className="pair-card">
                  <small>それまで</small>
                  <p>時間集計と予定変更の連絡は、また別の場所</p>
                </div>
                <div className="pair-join" aria-hidden="true"><i className="ri-arrow-right-line"></i></div>
                <div className="pair-card pair-card--after">
                  <small>DediAsin</small>
                  <p>稼働一覧と、簡易の連絡をシフトの隣に置く</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="block block--soft" id="auto">
        <div className="wrap">
          <div className="center">
            <p className="kicker">Auto assign</p>
            <h2>マスを一つずつ埋めなくても、下地はボタンで置ける</h2>
            <p className="lead">
              配置の最初から最後までを手入力しなくてもよくするための機能です。管理者が実行すると、提出済みの希望をもとに、明日以降の枠へ人を登録します。あとは中身を見て、違うところだけ直します。
            </p>
          </div>
          <div className="steps">
            <article className="step">
              <span className="step-no">01</span>
              <h3>スタッフが、自分の希望を出す</h3>
              <p>カレンダーの日付から、入れる時間や休暇を登録し、月単位で提出します。スマートフォンのブラウザから操作できます。下書きの間は、まだ配置の材料になりません。</p>
            </article>
            <article className="step">
              <span className="step-no">02</span>
              <h3>自動作成で、配置の下地を置く</h3>
              <p>基本の操作は、すでに決まっている配置を残したまま、空いている枠だけを埋めるものです。希望の時間に収まる枠へ割り当てます。過去の日と、当日の確定は動かしません。</p>
            </article>
            <article className="step">
              <span className="step-no">03</span>
              <h3>管理者が見て、必要なところだけ補正する</h3>
              <p>入りきらなかった枠や、入れ替えたい人はタイムライン上で直します。自動は下地です。誰を確定にするかの最終判断は、管理者の側に残しています。</p>
            </article>
          </div>
          <p className="note">
            明日以降をいったん作り直す操作もあります。どちらも実行前に範囲を確認します。希望が出ていない人や日は埋まりません。未配置のまま残った枠が、確認の対象です。
          </p>
        </div>
      </section>

      <section className="block" id="axes">
        <div className="wrap">
          <div className="center">
            <p className="kicker">Two views</p>
            <h2>人から見る。勤務先から見る。データは一つ</h2>
            <p className="lead">
              「この人は、何時からどの作業場か」「この時間のこの作業場には、誰がいるか」。現場で両方必要だった見方を、表示の切り替えで出せるようにしています。表を二つ保守する必要はありません。下の表は並びのイメージです。
            </p>
          </div>
          <div className="axes">
            <article className="axis">
              <div className="axis-head">
                <h3>人の軸</h3>
                <p>スタッフごとに、日付へ勤務が付きます。何時から、どの店舗の、どの配置先か。</p>
              </div>
              <div className="sheet" aria-hidden="true">
                <div className="sheet-row">
                  <div className="who">スタッフ A</div>
                  <div className="cells">
                    <div className="cell">9:00–13:00<br />本店 / 受付</div>
                    <div className="cell">13:00–17:00<br />本店 / フロア</div>
                    <div className="cell cell--empty">休み</div>
                  </div>
                </div>
                <div className="sheet-row">
                  <div className="who">スタッフ B</div>
                  <div className="cells">
                    <div className="cell">9:00–13:00<br />本店 / フロア</div>
                    <div className="cell cell--empty">希望のみ</div>
                    <div className="cell">10:00–15:00<br />別館 / 受付</div>
                  </div>
                </div>
                <p className="sheet-caption">行が人、列が日。セルの中が「いつ・どこ」。</p>
              </div>
            </article>
            <article className="axis">
              <div className="axis-head">
                <h3>勤務先の軸</h3>
                <p>配置先と時間帯ごとに、その枠へ入っている人が並びます。</p>
              </div>
              <div className="sheet" aria-hidden="true">
                <div className="sheet-row">
                  <div className="where">受付<br />9:00–13:00</div>
                  <div className="cells">
                    <div className="cell">スタッフ A</div>
                    <div className="cell">スタッフ C</div>
                    <div className="cell cell--empty">空き</div>
                  </div>
                </div>
                <div className="sheet-row">
                  <div className="where">フロア<br />13:00–17:00</div>
                  <div className="cells">
                    <div className="cell">スタッフ A</div>
                    <div className="cell cell--empty">空き</div>
                    <div className="cell">スタッフ D</div>
                  </div>
                </div>
                <p className="sheet-caption">行が「どこ・何時」、セルの中が「誰」。</p>
              </div>
            </article>
          </div>
        </div>
      </section>

      <section className="block block--tint" id="hours">
        <div className="wrap">
          <div className="center">
            <p className="kicker">Hours and messages</p>
            <h2>時間も、出勤の確認も、連絡も同じ場所</h2>
            <p className="lead">配置が決まってから別の表へ写す作業と、変更連絡を別の道具で始める手間を、シフトの画面側に寄せています。出勤の確認は、管理者が必要なときだけ使う機能です。</p>
          </div>
          <div className="side" style={{ marginTop: 32 }}>
            <article>
              <div className="icon-bubble"><i className="ri-time-line"></i></div>
              <h3>人ごとの稼働時間が、一覧で分かる</h3>
              <p>稼働集計では、スタッフごとに月間の目安時間と、確定シフトから数えた合計時間を並べます。目安を超えた人は、一覧の上で分かります。配置を終えたあとに、集計用の表を一から作らなくて済みます。出勤を記録したかどうかでは、この合計は変わりません。</p>
            </article>
            <article>
              <div className="icon-bubble"><i className="ri-chat-3-line"></i></div>
              <h3>予定のやり取りは、簡易の連絡で</h3>
              <p>画面の「連絡」から、スタッフと管理者の1対1と、管理者から全員へのお知らせができます。新着があると件数が付きます。シフトの変更を、見ている画面の外で探し回らなくてよいようにしてあります。</p>
            </article>
            <article>
              <div className="icon-bubble"><i className="ri-user-follow-line"></i></div>
              <h3>出勤の確認は、管理者が必要なときだけ</h3>
              <p>スタッフが当日の出勤を記録し、管理者が誰が来ているかを画面で確認できます。使わない現場では、そのままで構いません。これは確認用の記録です。出勤していなくても、確定したシフトの時間は稼働集計に入ります。</p>
            </article>
            <article>
              <div className="icon-bubble"><i className="ri-file-excel-2-line"></i></div>
              <h3>月ごとのシフト表と稼働集計を、Excelで出せる</h3>
              <p>確定したシフト表と、人ごとの稼働集計は、月を指定してExcelファイルに出力できます。画面で見た内容を、手元の表として残したいときに使います。</p>
            </article>
          </div>
        </div>
      </section>

      <section className="block" id="offer">
        <div className="wrap">
          <div className="center">
            <p className="kicker">For your sites</p>
            <h2>納品している仕組みを、貴社の置き方に合わせて調整する</h2>
            <p className="lead">
              パッケージをそのまま渡す形ではありません。法人・店舗・配置先という三つの階層、時間帯、誰がどの場所に入れるか、を現場の呼び方とルールに合わせて整えてからお渡しします。
            </p>
          </div>
          <div className="offer">
            <article>
              <h3>組織と時間帯</h3>
              <p>複数の法人や店舗、その下の配置先（受付やフロアなどの作業場）と、使う時間帯を登録してタイムラインを組みます。</p>
            </article>
            <article>
              <h3>希望は本人、確定は管理者</h3>
              <p>スタッフは希望の提出と、確定シフトの確認を行います。出勤の記録は、管理者が当日の出勤を確かめるための任意の機能です。配置を決める操作は管理者の画面にまとまっています。</p>
            </article>
            <article>
              <h3>パソコンでも、スマートフォンでも</h3>
              <p>ブラウザから使います。希望の入力など、スタッフ側の操作はスマートフォンを想定しています。幅の広いタイムラインは横にスクロールします。</p>
            </article>
            <article>
              <h3>直したあとも、同じデータ</h3>
              <p>手での追加や解除も、自動で置いた配置と同じタイムライン上で行います。人の軸と勤務先の軸は、その結果を見ているだけです。</p>
            </article>
          </div>
          <dl className="spec">
            <div className="spec-row">
              <dt>利用環境</dt>
              <dd>Webブラウザ（パソコン / スマートフォン）</dd>
            </div>
            <div className="spec-row">
              <dt>主な機能</dt>
              <dd>シフト希望の提出 / 配置の自動作成と手補正 / 人別・勤務先別のタイムライン / 人ごとの稼働集計 / 連絡（1対1・全体） / 出勤確認（任意。稼働集計とは別） / 月次のシフト表・稼働集計のExcel出力</dd>
            </div>
            <div className="spec-row">
              <dt>提供形態</dt>
              <dd>貴社専用の環境へ導入し、組織・時間帯・配置ルールに合わせて調整</dd>
            </div>
            <div className="spec-row">
              <dt>料金</dt>
              <dd>個別のお見積もり</dd>
            </div>
          </dl>
        </div>
      </section>

      <section className="block" style={{ paddingTop: 0 }}>
        <div className="wrap-narrow">
          <div className="cta">
            <h2>画面を見ながら、自社のシフトに合うか相談できます</h2>
            <p>いまのサービスと表のどこが二重になっているか、配置先と時間帯をどう置きたいか。そこからご提案します。</p>
            <div className="actions">
              <Link className="btn btn--fill" to="/contact">お問い合わせ</Link>
              <Link className="btn btn--line" to="/products">プロダクト一覧へ</Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default DediAsinMain;
